/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuMultiSelectSearch_itemSearch$ref = any;
export type SbSharedRefineMenuFilterMetal_itemSearch$ref = any;
export type SbSharedRefineMenuFilterMetal_itemSearch = {
    readonly " $fragmentRefs": SbSharedRefineMenuMultiSelectSearch_itemSearch$ref;
    readonly " $refType": SbSharedRefineMenuFilterMetal_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuFilterMetal_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuMultiSelectSearch_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'ae69f8d80b263ee351fd41b96821c40a';
export default node;
